type Props = {
  /** Keeps label `htmlFor` ids unique when multiple forms exist in the DOM. */
  fieldIdPrefix?: string;
  facebookUrl: string;
  instagramUrl: string;
  youtubeUrl: string;
  websiteUrl: string;
  otherUrl: string;
  onFacebookUrl: (v: string) => void;
  onInstagramUrl: (v: string) => void;
  onYoutubeUrl: (v: string) => void;
  onWebsiteUrl: (v: string) => void;
  onOtherUrl: (v: string) => void;
};

const inputClass = "mt-1 w-full rounded border border-brand-gray px-3 py-2 text-sm";
const labelClass = "block text-xs font-semibold text-brand-blue";

export function SocialLinksFormFields({
  fieldIdPrefix = "social",
  facebookUrl,
  instagramUrl,
  youtubeUrl,
  websiteUrl,
  otherUrl,
  onFacebookUrl,
  onInstagramUrl,
  onYoutubeUrl,
  onWebsiteUrl,
  onOtherUrl,
}: Props) {
  const p = fieldIdPrefix;
  return (
    <fieldset className="space-y-3 rounded-lg border border-brand-gray/60 bg-brand-gray/10 p-4">
      <legend className="px-1 text-xs font-bold uppercase tracking-wide text-brand-blue">
        Social &amp; web links
      </legend>
      <p className="text-xs text-brand-blue/65">
        Optional. Full URLs work best (e.g. <span className="font-mono">https://facebook.com/…</span>). Shown as
        icons on the public page.
      </p>
      <div className="space-y-1">
        <label htmlFor={`${p}-fb`} className={labelClass}>
          Facebook
        </label>
        <input
          id={`${p}-fb`}
          type="url"
          inputMode="url"
          autoComplete="off"
          placeholder="https://…"
          value={facebookUrl}
          onChange={(e) => onFacebookUrl(e.target.value)}
          className={inputClass}
        />
      </div>
      <div className="space-y-1">
        <label htmlFor={`${p}-ig`} className={labelClass}>
          Instagram
        </label>
        <input
          id={`${p}-ig`}
          type="url"
          inputMode="url"
          autoComplete="off"
          placeholder="https://…"
          value={instagramUrl}
          onChange={(e) => onInstagramUrl(e.target.value)}
          className={inputClass}
        />
      </div>
      <div className="space-y-1">
        <label htmlFor={`${p}-yt`} className={labelClass}>
          YouTube
        </label>
        <input
          id={`${p}-yt`}
          type="url"
          inputMode="url"
          autoComplete="off"
          placeholder="https://…"
          value={youtubeUrl}
          onChange={(e) => onYoutubeUrl(e.target.value)}
          className={inputClass}
        />
      </div>
      <div className="space-y-1">
        <label htmlFor={`${p}-web`} className={labelClass}>
          Website
        </label>
        <input
          id={`${p}-web`}
          type="url"
          inputMode="url"
          autoComplete="off"
          placeholder="https://…"
          value={websiteUrl}
          onChange={(e) => onWebsiteUrl(e.target.value)}
          className={inputClass}
        />
      </div>
      <div className="space-y-1">
        <label htmlFor={`${p}-other`} className={labelClass}>
          Other link
        </label>
        <input
          id={`${p}-other`}
          type="url"
          inputMode="url"
          autoComplete="off"
          placeholder="Any other URL (e.g. LinkedIn, X)"
          value={otherUrl}
          onChange={(e) => onOtherUrl(e.target.value)}
          className={inputClass}
        />
      </div>
    </fieldset>
  );
}
